(function() {
  function isMobile() {
    return window.innerWidth < 768;
  }

  var flkty = null;
  var autoId = null;
  var logoList = null;

  function initSlider() {
    if (flkty || !logoList) return;
    // If theme already initialized Flickity, destroy it first
    if (logoList.classList.contains('flickity-enabled')) {
      try {
        var existing = Flickity.data(logoList);
        if (existing) existing.destroy();
      } catch(e) {}
    }
    // Small delay to let CSS apply
    setTimeout(function() {
      flkty = new Flickity(logoList, {
        cellAlign: 'center',
        pageDots: false,
        prevNextButtons: true,
        contain: true,
        wrapAround: true,
        groupCells: 2
      });
      flkty.resize();
      autoId = setInterval(function() { if (flkty) flkty.next(true); }, 2000);
      logoList.addEventListener('mouseenter', function() { clearInterval(autoId); });
      logoList.addEventListener('mouseleave', function() { autoId = setInterval(function() { if (flkty) flkty.next(true); }, 2000); });
      logoList.addEventListener('touchstart', function() { clearInterval(autoId); }, { passive: true });
      logoList.addEventListener('touchend', function() { autoId = setInterval(function() { if (flkty) flkty.next(true); }, 2000); }, { passive: true });
    }, 100);
  }

  function destroySlider() {
    if (!flkty) return;
    clearInterval(autoId);
    flkty.destroy();
    flkty = null;
    autoId = null;
  }

  function handleResize() {
    if (isMobile()) {
      initSlider();
    } else {
      destroySlider();
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    logoList = document.querySelector('[id*="brand-logos"] .logo-list');
    if (!logoList) logoList = document.querySelector('.logo-list');
    if (!logoList) return;
    handleResize();
  });

  window.addEventListener('resize', handleResize);
})();
